import { render } from "./etDesign.vue?vue&type=template&id=12e6024c"
import script from "./etDesign.vue?vue&type=script&lang=js"
export * from "./etDesign.vue?vue&type=script&lang=js"

import "./etDesign.vue?vue&type=style&index=0&id=12e6024c&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__